import i18n from 'i18next'
import detector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import translationCY from './locales/cy.json'
import translationEN from './locales/en.json'
import translationNL from './locales/nl.json'

export type SupportedLanguage = 'en' | 'nl' | 'cy'

export const supportedLanguages: {
  code: SupportedLanguage
  label: string
  countryCode: string
}[] = [
  { code: 'en', label: 'English', countryCode: 'GB' },
  { code: 'nl', label: 'Nederlands', countryCode: 'NL' },
  { code: 'cy', label: 'Cymraeg', countryCode: 'GB' },
]

// eslint-disable-next-line import/no-named-as-default-member
i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: translationEN,
      },
      nl: {
        translation: translationNL,
      },
      cy: {
        translation: translationCY,
      },
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
  })

export const changeLanguage = (lng: SupportedLanguage) => {
  return i18n.changeLanguage(lng)
}

export default i18n
